var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Help } from '@hn-ui/icons';
import { forwardRef } from 'react';
import { styled } from 'styled-components';
var ScHelpIcon = styled(Help).withConfig({ displayName: "ScHelpIcon", componentId: "sc-1z0jmwq" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  vertical-align: middle;\n  margin: 0 4px;\n"], ["\n  vertical-align: middle;\n  margin: 0 4px;\n"])));
export var HelpIcon = forwardRef(function (props, ref) { return (_jsx(ScHelpIcon, __assign({ size: 20, color: 'black70', ref: ref, tabIndex: 0 }, props), void 0)); });
var templateObject_1;
